<!--
  This module is only available to users with the below setting
  * Receipt Log Unit List Only
   -- See A Summary Of All Units Instead Of Seeing A Summary Of All Receipt Logs.
-->
<template>
    <ReceiptLogUnits
        v-if="loaded"
        :receipt-log-units="units"
        :client-name="clientName"
        :current-page="currentPage"
        :per-page="unitsPerPage"
        :show-in-stock-only="showInStockOnly"
        @toggleInStockOnly="showInStockOnly = $event"
        @requestDelivery="requestDelivery"
        @perPageUpdated="setReceiptLogsPerPage($event)"
    />
</template>
<script>
import { mapState, mapActions } from "vuex";
import vuexstore from "./_store";
import ReceiptLogUnits from "./_components/ReceiptLogUnits.vue";
import { store, getters } from "src/global-store.js";

export default {
    name: "ReceiptLogUnitsModule",
    components: {
        ReceiptLogUnits,
    },
    data() {
        return {
            showInStockOnly: true,
            loaded: false,
            currentPage: 1,
        };
    },
    computed: {
        me() {
            return store.me;
        },
        isCustomer() {
            return getters.isCustomer();
        },
        isDesigner() {
            return getters.isDesigner();
        },
        ...mapState("$_receiptLogUnit", {
            units: (state) => state.allUnits,
            unitsPerPage: (state) => state.unitsPerPage,
        }),
        clientName() {
            if (this.isDesigner || this.isCustomer) {
                return `${this.me.customer_name}`;
            }
            return "";
        },
    },
    watch: {
        async showInStockOnly(value) {
            await this.fetchAllUnits({ excludeAvailableWhenZero: value });
        },
    },
    beforeCreate() {
        this.$store.registerModule("$_receiptLogUnit", vuexstore);
    },
    destroyed() {
        this.$store.unregisterModule("$_receiptLogUnit");
    },
    async created() {
        await this.fetchAllUnits({ excludeAvailableWhenZero: true });
        this.loaded = true;
    },
    methods: {
        ...mapActions("$_receiptLogUnit", ["fetchAllUnits", "setUnitsPerPage"]),
        ...mapActions("deliveryRequest", ["addToPendingReceiptLogs"]),
        requestDelivery(selectedUnits) {
            const receiptLogs = [
                ...new Set(selectedUnits.map((unit) => unit.receiptLog)),
            ];
            receiptLogs.forEach((log, index) => {
                receiptLogs[index].units = selectedUnits.filter(
                    (unit) => unit.receiptLogId === log.id,
                );
            });
            this.addToPendingReceiptLogs({ receiptLogs });
        },
    },
};
</script>
